import cruxAxios from 'app/cruxAxios'

const { get, post, put } = cruxAxios

export const linkedTracks = ({ page, adAccountId, size = 10 }) =>
  post(
    `/bcon/v2/services/keywordad/track-rights/adaccount/${adAccountId}/linked`,
    {},
    {
      params: {
        page,
        size,
      },
    }
  )
export const unlinkedTracks = ({ page, adAccountId, size = 10 }) =>
  get(
    `/bcon/v2/services/keywordad/track-rights/adaccount/${adAccountId}/unlinked`,
    {
      params: {
        page,
        size,
      },
    }
  )
export const createTrackRight = ({ trackId, adAccountId }) =>
  put(
    `/bcon/v2/services/keywordad/track-rights/${trackId}/adaccount/${adAccountId}`
  )
export const deleteTrackRight = ({ trackId, adAccountId }) =>
  cruxAxios.delete(
    `/bcon/v2/services/keywordad/track-rights/${trackId}/adaccount/${adAccountId}`
  )
export const createTrackAndTrackRight = ({ name, adAccountId }) =>
  post(`/bcon/v2/services/keywordad/track-rights/adaccount/${adAccountId}`, {
    name,
  })
export const getKakaoServices = ({ trackId, service }) =>
  get(`/bcon/v2/tracks/kakao-services/${trackId}/${service}`)
export const addKakaoServices = ({ trackId, targets }) =>
  post(`/bcon/v2/tracks/${trackId}/track-rights`, targets)
export const searchTrackAndTrackRight = ({ searchType, searchKey, page = 0 }) =>
  get(`/bcon/v2/tracks/search/roleinfo`, {
    params: {
      searchType,
      searchKey,
      page,
      size: 20,
    },
  })
export const postTrackMember = trackId =>
  post(`/bcon/v2/tracks/${trackId}/role/request`)
export const deleteRequestMember = ({ requestId, trackId }) =>
  cruxAxios.delete(`/bcon/v2/tracks/${trackId}/role/request`, {
    params: {
      requestId,
    },
  })
export const getTrackInfo = ({ trackId, adAccountId }) =>
  get(
    `/bcon/v2/services/keywordad/track-rights/adaccount/${adAccountId}/${trackId}/info`
  )
export const getEventList = ({ trackId, adAccountId }) =>
  post(
    `/bcon/v2/services/keywordad/tracks/${trackId}/events`,
    {},
    {
      params: {
        targetCategory: 'adaccount',
        targetKey: adAccountId,
      },
    }
  )
export const getTrackServiceByTrackId = ({ trackId, adAccountId }) =>
  get(`/bcon/v2/services/keywordad/tracks/${trackId}/services`, {
    params: {
      targetCategory: 'adaccount',
      targetKey: adAccountId,
    },
  })
export const getKakaoAccountIdLinkedTracks = () =>
  get('/bcon/v2/tracks/search/linked', {
    params: {
      searchType: '_',
      searchKey: 'ALL',
      size: 1,
    },
  })
